/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/organisasi?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/organisasi`;
    return http.post(url, payload.params);
  },

  detail({}, payload) {
    const url = `/organisasi/${payload}`;
    return http.get(url).then(({ data }) => data);
  },

  update({}, payload) {
    const url = `/organisasi/${payload.id}`;
    return http.patch(url, payload.params);
  },

  status({}, payload) {
    const url = `/organisasi/${payload.id}/${payload.status}`;
    return http.post(url);
  },

  uploadFoto({}, payload) {
    const url = `/organisasi/${payload.id}/upload-logo`;
    return http.post(url, payload.data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  delete({}, payload) {
    const url = `/organisasi/${payload.id}`;
    return http.delete(url);
  },

  ucm({}) {
    const url = `/organisasi/ucm-list`;
    return http.get(url).then(({ data }) => data.data);
  },
};
